import axios from "../../axios/index.js"


export default {
  GetAll() {
    return axios.get("produits", { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  GetAllFromNav() {
    return axios.get("produits/nav", { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  GetStock(code, id, qte) {
    return axios.get("produits/stock/" + code + "/" + id + "/" + qte, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  DeleteProduct(code, id, idd) {
    return axios.get("produits/Delete/Line/" + code + "/" + id + "/" + idd, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getListFilters() {
    return axios.get("produits/filters", { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getClientAnaltcsData(no) {
    return axios.get("clients/analytics/" + no, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  addImagestoArticles(code, data) {
    let formData = new FormData();
    formData.append("idObject", code)
    formData.append("object", "article")
    formData.append("name", code)
    formData.append("content", data.image1)
    formData.append("content2", data.image2)
    formData.append("content3", data.image3)
    return axios.post("produits/images", formData, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getimageByCodeArticle(code) {
    return axios.get("produits/images/" + code, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getListeCreationArticle(etat) {
    console.log(etat)
    return axios.get("produits/creations", { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  saveNouvelleCreationArticle(article) {
    let formData = new FormData();
    formData.append("designation", article.designation)
    formData.append("barcode", article.barcode)
    formData.append("code", article.code)

    if (article.image.filename != null) {
      formData.append("imagename", article.image.filename)
      formData.append("imageFile", article.image.fileURL1)
    }
    if (article.amc != null) {
      formData.append("amcname", article.amc.filename)
      formData.append("amcFile", article.amc.fileURL1)
    }

    formData.append("fournisseur", article.fournisseur)
    formData.append("fabricant", article.fabricant)
    formData.append("bureauPromotion", article.bureauPromotion)
    formData.append("laboratoire", article.laboratoire)
    formData.append("nomEmetteur", article.nomEmetteur)
    formData.append("telEmetteur", article.telEmetteur)
    formData.append("tva", article.tva)
    formData.append("type", article.type)
    formData.append("dci_1", article.dci_1)
    formData.append("dci_2", article.dci_2)
    formData.append("gamme", article.gamme)
    formData.append("remise", article.remise)
    formData.append("colisage", article.colisage)
    formData.append("contenance", article.contenance)
    formData.append("fodec", article.fodec)
    formData.append("typePharma", article.typePharma)
    formData.append("chaineFroid", article.chaineFroid)

    if (article.generique != null)
      formData.append("generique", article.generique)

    if (article.princeps != null)
      formData.append("princeps", article.princeps)

    formData.append("classeTherapeutique", article.classeTherapeutique)

    formData.append("prixUnitHTGrossiste", article.prixUnitHTGrossiste)
    formData.append("prixVenteConseille", article.prixVenteConseille)
    formData.append("coutDRTConsommation", article.coutDRTConsommation)

    return axios.post("produits/creations", formData, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  gteFilesDetailsById(id) {
    return axios.get("files/" + id + "&creepar=" + 'creePar', { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  }
}
